<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div>
    <select v-model="level" @change="change">
      <option disabled value="">Please select one</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option selected value="4">4</option>
      <option value="5">5</option>
      <option value="6">6</option>
      <option value="7">7</option>
      <option value="8">8</option>
    </select>
    <span>Level: {{ level }}</span>
    </div>
    <div>
    <select v-model="block" @change="change">
      <option disabled value="" >Please select one</option>
       <option value="2x2x2" selected>2x2x2</option>
       <option value="2x2x2_2x2x3">2x2x2 &gt; 2x2x3</option>
       <option value="roux1">Roux FB</option>
       <option value="roux2">Roux SB</option>
       <option value="roux2_fs">Roux SB (First square)</option>
       <option value="roux2_lp">Roux SB (Last pair)</option>
    </select>
    <span>Block: {{ block }}</span>
    </div>
    <h2>Scramble</h2>
    <p> {{ scramble }} </p>
    <h2>Solution</h2>
    <button class="button-show" v-if="!showSolution" @click="showSolution = true"> SHOW </button>
    <p v-else> {{ solution }} </p>
    <div>
    <button class="button-next" @click="load">NEXT</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      scramble: '',
      solution: '',
      showSolution: false,
      block: 'roux1',
      level: '4'
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    change() {
      this.load();
    },
    async load() {
      this.showSolution = false;
      const { data } = await axios.get(`https://cors-anywhere.herokuapp.com/https://cubegrass.appspot.com/block_trainer/get_block.php?levels=${this.level}&block=${this.block}`)
      console.log(data)
      this.scramble = data.alg_long;
      this.solution = data.alg_short;

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.button-show {
  width: 150px;
  height: 50px;
  margin: 10px;
}

.button-next {
  width: 100px;
  height: 50px;
  margin: 10px;
}
</style>
